import React from 'react';
import { drapcodeIcon } from '../custom/icon-library';
const InfoCard = ({ title, icon = 'description', dataTip }) => {
  return (
    <div className="input-group-append">
      <span className="input-group-text" data-tip={dataTip} title={title}>
        <i className={`wb ${drapcodeIcon(icon)}`}></i>
      </span>
    </div>
  );
};

export default InfoCard;
